import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Title } from "chart.js";
import { Box, Typography } from "@mui/material";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title);

export default function MostUsedUsersBar({ rows }) {
  const data = rows || [];

  if (data.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" sx={{ color: "#374151", fontWeight: 600 }}>No app sessions recorded yet</Typography>
        <Typography variant="caption" sx={{ color: "#9aa1ac" }}>
          App opens are counted from the next app release onwards.
        </Typography>
      </Box>
    );
  }

  const chartData = {
    labels: data.map((r) => r.name),
    datasets: [{
      data: data.map((r) => r.opens || 0),
      backgroundColor: "#7c3aed",
      borderRadius: 6,
      barThickness: 18,
    }],
  };

  return (
    <Box sx={{ height: Math.max(180, data.length * 44), width: "100%" }}>
      <Bar
        data={chartData}
        options={{
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: { callbacks: { label: (ctx) => `${ctx.parsed.x} app opens` } },
          },
          scales: {
            x: {
              beginAtZero: true,
              grid: { color: "#f1f5f9" },
              ticks: { color: "#374151", precision: 0 },
              title: { display: true, text: "App Opens", color: "#6b7280", font: { size: 11 } },
            },
            y: { grid: { display: false }, ticks: { color: "#111827", font: { weight: 700 } } },
          },
        }}
      />
    </Box>
  );
}
